import React from 'react';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { Cases } from '../components/Cases';
import { Testimonials } from '../components/Testimonials';
import { Process } from '../components/Process';
import { Contact } from '../components/Contact';
import { PainPoints } from '../components/PainPoints';
import { BannerCTA } from '../components/BannerCTA';
import { ProblemSolution } from '../components/ProblemSolution';

export const Home: React.FC = () => {
  return (
    <div className="animate-fade-in-up">
      <Hero />
      <PainPoints />
      <ProblemSolution />
      <BannerCTA />
      <Features />
      <Cases />
      <Testimonials />
      <Process />
      <Contact />
    </div>
  );
};